import {
    REQUEST_PURCHASE_QUOTES,
    FETCH_PURCHASE_QUOTES_SUCCESS,
    FETCH_PURCHASE_QUOTES_FAILURE,
    SELECT_PURCHASE_QUOTE,
    RESET_CURRENT_PURCHASE_QUOTE,
    REQUEST_PURCHASE_QUOTE_DETAIL,
    FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS,
    FETCH_PURCHASE_QUOTE_DETAIL_FAILURE,
    REQUEST_CREATING_PURCHASE_QUOTE,
    CREATE_PURCHASE_QUOTE_SUCCESS,
    CREATE_PURCHASE_QUOTE_FAILURE,
    REQUEST_PURCHASE_QUOTE_PLACE,
    PURCHASE_QUOTE_PLACE_SUCCESS,
    PURCHASE_QUOTE_PLACE_FAILURE,
    REQUEST_EDITING_PURCHASE_QUOTE,
    EDIT_PURCHASE_QUOTE_SUCCESS,
    EDIT_PURCHASE_QUOTE_FAILURE,
    REQUEST_NUM_PURCHASE_QUOTES,
    FETCH_NUM_PURCHASE_QUOTES_SUCCESS,
    FETCH_NUM_PURCHASE_QUOTES_FAILURE,
    REQUEST_DELETE_PURCHASE_QUOTE,
    DELETE_PURCHASE_QUOTE_SUCCESS,
    DELETE_PURCHASE_QUOTE_FAILURE,

} from '../actions/type';

const INITIAL_STATE = {
    all: [],
    numPurchaseQuotes: null,
    currentPurchaseQuote: null,
    currentPurchaseQuoteDetail: null,
    isLoading: true,
    error: null,
    detailIsLoading: false,
    numPurchaseQuotesLoading: false,
    numPurchaseQuotesError: null,
    detailError: null,
    purchaseQuoteIsCreating: false,
    purchaseQuoteCreateError: null,
    purchaseQuoteCreated: null,
    purchaseQuoteIsPlacing: false,
    purchaseQuotePlaceError: null,
    purchaseQuotePlaced: false,
    purchaseQuoteIsEditing: false,
    purchaseQuoteEditError: null,
    purchaseQuoteEdited: false,
    purchaseQuoteIsDeleting: false,
    purchaseQuoteDeleteError: null,
    purchaseQuoteIsDeleted: false,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        // Product action handlers
        case REQUEST_PURCHASE_QUOTES:
            return { ...state, error: null, isLoading: true };
        case FETCH_PURCHASE_QUOTES_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_PURCHASE_QUOTES_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_PURCHASE_QUOTE:
            return {...state, currentPurchaseQuote: action.payload };
        case RESET_CURRENT_PURCHASE_QUOTE:
            return { ...state, currentPurchaseQuote: null, currentPurchaseQuoteDetail: null, purchaseQuoteCreateError: null, purchaseQuoteEditError: null, purchaseQuoteCreated: null, purchaseQuotePlaced: false };
        case REQUEST_PURCHASE_QUOTE_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_PURCHASE_QUOTE_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentPurchaseQuoteDetail: action.payload, detailError: null, detailIsLoading: false };
        case FETCH_PURCHASE_QUOTE_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_CREATING_PURCHASE_QUOTE:
            return { ...state, purchaseQuoteIsCreating: true, purchaseQuoteCreateError: null, purchaseQuoteCreated: null };
        case CREATE_PURCHASE_QUOTE_SUCCESS:
            return { ...state, purchaseQuoteIsCreating: false, purchaseQuoteCreateError: null, purchaseQuoteCreated: action.payload.data };
        case CREATE_PURCHASE_QUOTE_FAILURE:
            const purchaseQuoteCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseQuoteIsCreating: false, purchaseQuoteCreateError: purchaseQuoteCreateError, purchaseQuoteCreated: null };

        case REQUEST_PURCHASE_QUOTE_PLACE:
            return { ...state, purchaseQuoteIsPlacing: true, purchaseQuotePlaceError  : null, purchaseQuotePlaced: false };
        case PURCHASE_QUOTE_PLACE_SUCCESS:
            return { ...state, purchaseQuoteIsPlacing: false, purchaseQuotePlaceError: null, purchaseQuotePlaced: true };
        case PURCHASE_QUOTE_PLACE_FAILURE:
            const purchaseQuotePlaceError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseQuoteIsPlacing: false, purchaseQuotePlaceError: purchaseQuotePlaceError, purchaseQuotePlaced: false };


        case REQUEST_EDITING_PURCHASE_QUOTE:
            return { ...state, purchaseQuoteIsEditing: true, purchaseQuoteEditError: null, purchaseQuoteEdited: false, purchaseQuoteCreated: null };
        case EDIT_PURCHASE_QUOTE_SUCCESS:
            return { ...state, purchaseQuoteIsEditing: false, purchaseQuoteEditError: null, purchaseQuoteEdited: true };
        case EDIT_PURCHASE_QUOTE_FAILURE:
            const purchaseQuoteEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, purchaseQuoteIsEditing: false, purchaseQuoteEditError: purchaseQuoteEditError, purchaseQuoteEdited: false };
        case REQUEST_NUM_PURCHASE_QUOTES:
            return { ...state, numPurchaseQuotesError: null, numPurchaseQuotesLoading: true };
        case FETCH_NUM_PURCHASE_QUOTES_SUCCESS:
            return { ...state, numPurchaseQuotes: action.payload.data.number, numPurchaseQuotesLoading: false };
        case FETCH_NUM_PURCHASE_QUOTES_FAILURE:
            return { ...state, numPurchaseQuotesError: action.payload.data, numPurchaseQuotesLoading: false };
        case REQUEST_DELETE_PURCHASE_QUOTE:
            return { ...state, purchaseQuoteIsDeleting: true, purchaseQuoteDeleteError: null, purchaseQuoteIsDeleted: false };
        case DELETE_PURCHASE_QUOTE_SUCCESS:
            return { ...state, purchaseQuoteIsDeleting: false, purchaseQuoteDeleteError: null, purchaseQuoteIsDeleted: true };
        case DELETE_PURCHASE_QUOTE_FAILURE:
            const purchaseQuoteDeleteError = action.payload.data || { messate: action.payload.message };
            return { ...state, purchaseQuoteIsDeleting: false, purchaseQuoteDeleteError: purchaseQuoteDeleteError, purchaseQuoteIsDeleted: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/purchaseQuotes_reducer.js